export const API_BASE_URL = process.env.REACT_APP_SERVER as string;

if (!API_BASE_URL) {
  throw new Error("REACT_APP_SERVER is not defined. Set it in .env.production (https://api.pixelwelfare.org/).");
}

console.log("[API_BASE_URL]", API_BASE_URL);

export const API_ENDPOINTS = {
  login: "/login",
  refresh: "/public/token-refresh",
  me: "me",
  adminClientList: "/admin/client/list",
  adminClientSosContactList: "/admin/client/{id}/sos/contact/list",
  surveyCsv: "/admin/active-data/survey/csv",
  adminClientSosMessage: (id: number) => `/admin/client/${id}/sos/message`,
  adminClientMessage: "/admin/client/{id}/message",
  adminClientSosMessageList: (id: number) => `/admin/client/${id}/sos/message/list`,
};
